var n = {
  id: void 0,
  customerId: void 0,
  firstname: void 0,
  lastname: void 0,
  username: void 0,
  email: void 0,
  newEmail: void 0,
  locale: void 0,
  fontSize: void 0,
  online: void 0,
  impersonatedUntil: void 0,
  loggedInUntil: void 0,
  authenticated: !1,
  sessionReady: !1,
  sessionInvalid: !1,
  roles: []
}, r = (s) => ({
  setUser: (e) => s((i) => ({ user: {
    ...i.user,
    id: e.id,
    firstname: e.firstname,
    lastname: e.lastname,
    username: e.username,
    email: e.email,
    authenticated: e.id != null
  } })),
  clearUser: () => s((e) => ({ user: {
    ...e.user,
    id: void 0,
    customerId: void 0,
    username: void 0,
    authenticated: !1,
    sessionInvalid: !1
  } })),
  setOnlineState: (e) => s((i) => ({ user: {
    ...i.user,
    online: e
  } })),
  setLocale: (e) => s((i) => ({ user: {
    ...i.user,
    locale: e
  } })),
  setFontSize: (e) => s((i) => ({ user: {
    ...i.user,
    fontSize: e
  } })),
  setImpersonated: (e) => s((i) => ({ user: {
    ...i.user,
    impersonatedUntil: e != null ? new Date((/* @__PURE__ */ new Date()).getTime() + e.timeout * 1e3) : void 0
  } })),
  setLoggedInUntil: (e) => s((i) => ({ user: {
    ...i.user,
    loggedInUntil: e != null ? new Date((/* @__PURE__ */ new Date()).getTime() + e.timeout * 1e3) : void 0
  } })),
  setNewEmail: (e) => s((i) => ({ user: {
    ...i.user,
    newEmail: e
  } })),
  setSessionReady: (e) => s((i) => ({ user: {
    ...i.user,
    sessionReady: e
  } })),
  setSessionInvalid: (e) => s((i) => i.user.sessionInvalid === e ? i : { user: {
    ...i.user,
    sessionInvalid: e
  } }),
  setRoles: (e) => s((i) => ({ user: {
    ...i.user,
    roles: e
  } }))
});
export {
  r as createAdminUserActions,
  n as initialAdminUserState
};

//# sourceMappingURL=adminUser.action.js.map